export default {
  0: {
    // default 1
    criteria: [
      { id: "points" },
      { id: "goalDifference" },
      { id: "goalsScored" },
      {
        id: "headToHead",
        subCriteria: [
          { id: "points" },
          { id: "goalDifference" },
          { id: "goalsScored" },
        ],
        applyRecursively: true,
      },
    ],
  },
  1: {
    // default 2
    criteria: [
      { id: "points" },
      {
        id: "headToHead",
        subCriteria: [
          { id: "points" },
          { id: "goalDifference" },
          { id: "goalsScored" },
        ],
        applyRecursively: true,
      },
      { id: "goalDifference" },
      { id: "goalsScored" },
    ],
  },
  2: {
    // default sets
    criteria: [
      { id: "points" },
      { id: "numMatchesWon" },
      {
        id: "headToHead",
        subCriteria: [
          { id: "points" },
          { id: "numMatchesWon" },
          { id: "setDifference" },
        ],
        applyRecursively: true,
      },
      { id: "setDifference" },
      { id: "goalDifference" },
    ],
  },
};
